import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OperationType } from '../../../../../core/models/enums/core.enums';
import DynamicComponent from '../../../../../core/presentations/DynamicComponent';
import PrwcBasicButton from '../../../../../ui/widgets/custom/buttons/PrwcBasicButton';
import PrwcSidebar from '../../../../../ui/widgets/custom/PrwcSidebar';
import PrwcTabPanel from '../../../../../ui/widgets/custom/PrwcTabPanel';
import PrwcTabView from '../../../../../ui/widgets/custom/PrwcTabView';
import { useTimeAndAttendanceFacade } from '../../facades/TimeAndAttendance.facade';
import { TimeAndAttendanceGenericConstants } from '../../models/constants/time-and-attendance-generic.constants';

const ShiftDetailsPage = () => {
  const { t } = useTranslation();
  const [isSideBarVisible, setIsSideBarVisible] = useState(false);
  const timeAndAttendanceFacade: any = useTimeAndAttendanceFacade();
  const [activeTabIndex, setActiveTabIndex] = useState(
    timeAndAttendanceFacade.getShiftDetailsActiveTabIndex()
  );

  const [operationType, setOperationType] = useState(OperationType.ADD)
  const [selectedRowData, setSelectedRowData] = useState(null);

  const changeActiveTab = (activeTabIndex: number) => {
    setActiveTabIndex(activeTabIndex);
    timeAndAttendanceFacade.setShiftDetailsActiveTabIndex(activeTabIndex);
  };

  const handleAddCategory = () => {
    setOperationType(OperationType.ADD);
    setSelectedRowData(null);
    setIsSideBarVisible(true);
  };

  const handleEditCategory = (rowData: any) => {
    setOperationType(OperationType.EDIT);
    setSelectedRowData(rowData);
    console.log("handle edit ---");
    console.log(rowData);
    setIsSideBarVisible(true);
  };

  return (
    <div>
      <div className="flex items-center justify-between px-2 border-gray-300">
        <div className="text-2xl font-semibold text-gray-700 ">
          {t("shiftDetails.label.shiftDetails")}
        </div>
        <div>
          <PrwcBasicButton
            labelKey={
              TimeAndAttendanceGenericConstants.Tabs[activeTabIndex].addLabelKey
            }
            className="h-8 my-1 bg-blue-700 border-blue-700 min-w-28 p-button-sm"
            onClick={handleAddCategory}
          ></PrwcBasicButton>
        </div>
      </div>

      <PrwcSidebar
        headerTitle={
          operationType === OperationType.ADD
            ? t(TimeAndAttendanceGenericConstants.Tabs[activeTabIndex].addLabelKey)
            : t(
              TimeAndAttendanceGenericConstants.Tabs[activeTabIndex].editLabelKey
              )
        }
        isSideBarVisible={isSideBarVisible}
        enableFullScreen={true}
        position="right"
        className="p-sidebar-md"
        onHide={() => setIsSideBarVisible(false)}
      >
        <DynamicComponent
          component={
            TimeAndAttendanceGenericConstants.Tabs[activeTabIndex].sidebarComponent
          }
          operationType={operationType}
          data={selectedRowData}
        ></DynamicComponent>
      </PrwcSidebar>

      <div className="mt-4">
        <PrwcTabView
          activeIndex={activeTabIndex}
          changeActiveTab={changeActiveTab}
        >
          {TimeAndAttendanceGenericConstants.Tabs.map(
            (tab: any, index: number) => (
              <PrwcTabPanel key={index} header={t(tab.headerKey)}>
                <DynamicComponent
                  component={tab.listComponent}
                  onEdit={handleEditCategory}
                ></DynamicComponent>
              </PrwcTabPanel>
            )
          )}
        </PrwcTabView>
      </div>
    </div>
  );
};

export default ShiftDetailsPage;
